import AccountForm from '../../components/AccountForm/AccountForm';
import './SignUp.sass';
export default function SignUp() {
    return (
        <main id="sign-up">
            <AccountForm page="signup" />
        </main>
    );
}
